import { FormEvent, useState } from "react";
import { addConversationToGroup } from "../../api/index";
import { useConversationGroupContext } from "./context/ConversationsProvider";
import classes from "../../details/styles.module.scss";
import ConversationInputForm from "../ConversationInputForm";
import { ConversationGroup } from "./context/types";
import { DbtDocsShareDetails } from "../types";

interface Props {
  conversationGroupId: ConversationGroup["conversation_group_id"];
  shareId: DbtDocsShareDetails["share_id"];
}

const ConversationReplyForm = ({ conversationGroupId, shareId }: Props) => {
  const { currentUser, users, onReplyAdd, source } = useConversationGroupContext();
  const usersList = Object.values(users);
  const [replyText, setReplyText] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const submitReply = async (e?: FormEvent) => {
    e?.stopPropagation();
    e?.preventDefault();

    if (!shareId || !conversationGroupId) {
      return;
    }
    setIsLoading(true);
    console.log("saving reply", shareId, conversationGroupId, {
      message: replyText,
    });
    try {
      await addConversationToGroup(
        shareId,
        conversationGroupId,
        {
          message: replyText,
        },
        source
      );
      onReplyAdd();
    } catch (err) {
      console.error("error while saving reply", err);
    }

    setIsLoading(false);
    setReplyText("");
  };

  return (
    <div className={classes.replyForm}>
      <form onSubmit={submitReply} className="">
        <ConversationInputForm
          comment={replyText}
          setComment={setReplyText}
          loading={isLoading}
          users={Object.values(usersList)}
          currentUser={currentUser || null}
          onEnterKeypress={submitReply}
        />
      </form>
    </div>
  );
};

export default ConversationReplyForm;
